<template>
  <div>
    <el-tabs v-model="accountFlag" @tab-click="search" v-if="[0].includes($store.state.userInfo.userType)">
      <el-tab-pane label="资源管理" name="resource">
        <module-card title="菜单管理">
          <el-button type="primary" @click="addResource" style="margin-bottom: 20px">添加资源</el-button>
          <el-table border :data="resourceData" v-loading="resourceLoading" row-key="id" :tree-props="{children: 'childNode', hasChildren: 'hasChildren'}" >
            <el-table-column
              label="菜单名称"
              width="250"
              prop="menuName">
            </el-table-column>
            <el-table-column
              label="页面路径"
              prop="menuUrl">
            </el-table-column>
            <el-table-column
              label="菜单图标名称"
              prop="menuIcon">
            </el-table-column>
            <el-table-column
              label="menuFullPath"
              prop="menuFullPath">
            </el-table-column>
            <el-table-column
              label="上级菜单ID"
              prop="menuParentId">
            </el-table-column>
            <el-table-column
              label="菜单等级"
              width="120"
              prop="menuLevel">
            </el-table-column>
            <el-table-column
              label="排序字段"
              width="120"
              prop="menuSort">
            </el-table-column>
            <el-table-column
              label="菜单类型"
              prop="menuType">
              <template slot-scope="scope">
                {{ scope.row.menuType === 0 ? '菜单' : '按钮' }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="250"
              fixed="right">
              <template slot-scope="scope">
                  <el-button type="text" @click="addResource(scope.row)" style="padding: 10px" v-show="scope.row.menuType !== 1">添加资源</el-button>
                  <el-button type="text" @click="editResource(scope.row)" style="padding: 10px">编辑</el-button>
                  <el-button type="text" @click="delResource(scope.row)" style="padding: 10px">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </module-card>
      </el-tab-pane>
      <!-- 角色管理 -->
      <el-tab-pane label="角色管理" name="role">
        <!-- <module-card title="筛选">
          <el-form :model="searchForm" :inline="true" label-width="85px" label-position="left">
            <el-form-item label="角色名称">
              <el-input v-model="searchForm.roleName" placeholder="请输入角色名称" :clearable="true"></el-input>
            </el-form-item>
            <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
          </el-form>
        </module-card> -->
        <module-card title="角色管理">
          <el-table class="table" border :data="roleData" v-loading="roleLoading">
            <el-table-column
              label="角色名称"
              prop="roleName">
            </el-table-column>
            <el-table-column
              label="角色状态"
              prop="roleStatus">
              <template slot-scope="scope">
                {{ scope.row.roleStatus === 0 ? '正常' : '暂停' }}
              </template>
            </el-table-column>
            <el-table-column
              label="角色类型"
              prop="defaultUserType">
            </el-table-column>
            <el-table-column
              label="角色昵称"
              prop="roleRemark">
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              fixed="right">
              <template slot-scope="scope">
                  <el-button type="text" @click="showEditRole(scope.row)" style="padding: 10px">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination :count="total" :page-no="searchForm.pageNo" :size="searchForm.pageSize" @changePage="value => { searchForm.pageNo = value;getList() }"></pagination>
        </module-card>
      </el-tab-pane>
    </el-tabs>

    <dialog-info title="添加菜单" :visible.sync="showResourceDiolog" :confirmLoading="resourceLoading" @close="resourceForm = $options.data().resourceForm; $refs.resourceForm.clearValidate()" @confirm="addMenu">
      <el-form ref="resourceForm" :model="resourceForm" label-position="left" :rules="resourceRule" label-width="110px">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="resourceForm.menuName" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="页面路径" prop="menuUrl">
          <el-input v-model="resourceForm.menuUrl" placeholder="请输入页面路径"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标名称" prop="menuIcon">
          <el-input v-model="resourceForm.menuIcon" placeholder="请输入菜单图标名称"></el-input>
        </el-form-item>
        <el-form-item label="menuFullPath" prop="menuFullPath">
          <el-input v-model="resourceForm.menuFullPath" placeholder="请输入上级F_menu_full_path+上级F_id拼接"></el-input>
        </el-form-item>
        <!-- <el-form-item label="上级菜单ID" prop="menuParentId">
          <el-input v-model="resourceForm.menuParentId" placeholder="请输入直属上级菜单ID"></el-input>
        </el-form-item>
        <el-form-item label="菜单等级" prop="menuLevel">
          <el-input v-model="resourceForm.menuLevel" placeholder="请输入菜单等级"></el-input>
        </el-form-item> -->
        <el-form-item label="排序字段" prop="menuSort">
          <el-input v-model="resourceForm.menuSort" placeholder="请输入排序字段"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menuType">
          <el-select v-model="resourceForm.menuType" placeholder="请选择菜单类型" filterable clearable>
            <el-option v-for="(item, index) in menuTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作类型" prop="menuOpt">
          <el-input v-model="resourceForm.menuOpt" placeholder="请输入操作类型"></el-input>
        </el-form-item>
        <el-form-item label="页面是否展示" prop="menuHidden">
          <el-select v-model="resourceForm.menuHidden" placeholder="请选择菜单类型" filterable clearable>
            <el-option v-for="(item, index) in menuHiddenList" :key="index" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </dialog-info>

    <dialog-info title="编辑角色" :visible.sync="showRoleDiolog" :confirmLoading="roleLoading" @confirm="editRole" @close="closeRoleDialog">
      <el-form ref="dataForm" :model="dataForm" label-position="left" :rules="dataRule" label-width="70px">
        <el-form-item label="角色权限">
          <el-tree
            v-loading="treeLoading"
            :data="data"
            show-checkbox
            node-key="id"
            ref="tree"
            check-strictly
            @check-change="checkChange"
            :props="{ children: 'childNode', label: 'menuName' }">
          </el-tree>
        </el-form-item>
      </el-form>
    </dialog-info>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import pagination from '@/components/pagination'
export default {
  name: 'resourceManage',
  components: {
    dialogInfo,
    pagination
  },
  data () {
    return {
      showResourceDiolog: false,
      showRoleDiolog: false,
      resourceLoading: false,
      roleLoading: false,
      treeLoading: false,
      accountFlag: 'resource',
      data: [],
      resourceData: [],
      roleData: [],
      resourceForm: {
        menuParentId: 0,
        menuLevel: 1,
        menuSort: 0,
        menuFullPath: '0_',
        menuName: '',
        menuUrl: '',
        menuIcon: '',
        menuType: '',
        menuOpt: '',
        menuHidden: '',
        id: ''
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10
      },
      count: 0,
      menuTypeList: [{
        value: 0,
        label: '菜单'
      }, {
        value: 1,
        label: '按钮'
      }],
      menuHiddenList: [{
        value: 0,
        label: '展示'
      }, {
        value: 1,
        label: '不展示'
      }],
      resourceRule: {
        menuName: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        }]
      },
      dataForm: {
        resourceIds: [],
        id: ''
      }
    }
  },
  computed: {
  },
  mounted () {
    this.getList()
  },
  methods: {
    search () {
      this.getList()
    },
    addResource (row) {
      if (row.id) {
        this.resourceForm.menuParentId = row.id
        this.resourceForm.menuLevel = row.menuLevel + 1
        row.menuLevel === 1 ? this.resourceForm.menuFullPath = `${row.menuFullPath}${row.id}` : this.resourceForm.menuFullPath = `${row.menuFullPath}_${row.id}`
      }
      if (row.childNode) {
        this.resourceForm.menuSort = row.childNode.length
      } else {
        this.resourceForm.menuSort = this.resourceData.length
      }
      this.showResourceDiolog = true
    },
    editResource (row) {
      Object.keys(row).forEach(key => {
        row[key] && (this.resourceForm[key] = row[key])
      })
      this.showResourceDiolog = true
    },
    delResource (row) {
      this.$confirm('是否删除此菜单?', '温馨提示').then(res => {
        this.$axios.post(this.$api.resourceDelete, { id: row.id }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              showClose: 'true',
              message: '删除成功'
            })
            this.getList()
          }
        })
      }).catch(() => {})
    },
    getList () {
      this.resourceLoading = true
      this.roleLoading = true
      const urlApi = this.accountFlag === 'resource' ? 'resourceList' : 'roleList'
      const urlType = this.accountFlag === 'resource' ? 'get' : 'post'
      this.$axios[urlType](this.$api[urlApi], this.accountFlag === 'role' ? this.searchForm : '').then(res => {
        if (res.respCode === '0') {
          if (this.accountFlag === 'resource') {
            this.resourceData = res.data
            this.data = res.data
          } else {
            this.roleData = res.data.list
            this.total = res.data.count
          }
        }
        this.resourceLoading = false
        this.roleLoading = false
      })
    },
    addMenu () {
      this.$refs.resourceForm.validate((valid) => {
        if (valid) {
          let api
          let message
          if (!this.resourceForm.id) {
            api = 'resourceAdd'
            message = '新增成功'
          } else {
            api = 'resourceEdit'
            message = '修改成功'
          }
          this.$axios.post(this.$api[api], this.resourceForm).then(res => {
            if (res.respCode === '0') {
              this.$message({
                type: 'success',
                showClose: 'true',
                message: message
              })
              this.showResourceDiolog = false
              this.getList()
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    showEditRole (row) {
      this.showRoleDiolog = true
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(row.resourceIds)
      })
      this.dataForm.id = row.id
    },
    editRole () {
      // console.log(this.$refs.tree.getCheckedKeys())
      this.dataForm.resourceIds = this.$refs.tree.getCheckedKeys()
      this.$axios.post(this.$api.roleEdit, this.dataForm).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            showClose: 'true',
            message: '修改成功'
          })
          this.showRoleDiolog = false
          this.getList()
        }
      })
    },
    checkChange (data, check) {
      // 父节点操作
      if (data.menuParentId !== 0) {
        if (check === true) {
          // 如果选中，设置父节点为选中
          this.$refs.tree.setChecked(data.menuParentId, true)
        } else {
          // 如果取消选中，检查父节点是否该取消选中（可能仍有子节点为选中状态）
          var parentNode = this.$refs.tree.getNode(data.menuParentId)
          var parentHasCheckedChild = false
          if (parentNode.childNodes) {
            for (var i = 0, parentChildLen = parentNode.childNodes.length; i < parentChildLen; i++) {
              if (parentNode.childNodes[i].checked === true) {
                parentHasCheckedChild = true
                break
              }
            }
          }
          if (!parentHasCheckedChild) {
            this.$refs.tree.setChecked(data.menuParentId, false)
          }
        }
      }
      // 子节点操作，如果取消选中，取消子节点选中
      if (data.childNode != null && check === false) {
        for (var j = 0, len = data.childNode.length; j < len; j++) {
          var childNode = this.$refs.tree.getNode(data.childNode[j].id)
          if (childNode.checked === true) {
            this.$refs.tree.setChecked(childNode.data.id, false)
          }
        }
      }
    },
    closeRoleDialog () {
      this.dataForm = this.$options.data().dataForm
      this.$refs.tree.setCheckedKeys([])
      // 折叠所有树节点
      for (var i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.accountMsg{
  padding-top: 14px;
  p{
    font-size: 16px;
    color: #333;
    line-height: 16px;
    margin-bottom: 25px;
    span{
      width: 100px;
      display: inline-block;
    }
  }
}
/deep/.el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    text-align: left;
}
</style>
